import Footer from "../components/Footer";
import HeroPages from "../components/HeroPages";
import TariffTable from "../components/Tariff";
import AboutMain from "../images/about/about-main.png";


function About() {
  return (
    <>
      <section className="about-page">
        <HeroPages name="About" />
        <div className="container">
          <div className="about-main">
            <img
              className="about-main__img"
              src={AboutMain}
              alt="car-renting"
            />
            <div className="about-main__text">
              <h3>About Company</h3>
              <h3>TheGleanAuto Provides Affordable, Safe and Comfortable Car Rental Experience</h3>
              <p>
              Passionate and well experienced in sourcing and maintaining Reliable, Safe and Comfortable proven Cars.
              We choose top quality cars with high safety standards and craft them with TheGleanAuto comfort standards like premium music system, reverse camera, artificial leather car seats, gentle perfume and wireless mobile charging solution which makes you feel like your personal and homely car.
              </p>
              
            </div>
          </div>
          <TariffTable />
        </div>
      </section>
      <div className="book-banner">
        <div className="book-banner__overlay"></div>
        <div className="container">
          <div className="text-content">
            <h2>Book a car by getting in touch with us</h2>
            <span>
              <i className="fa-solid fa-phone"></i>
              <h3>+1-6478520014</h3>
            </span>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default About;
